import { useContext, useState } from "react";
import { QueryClientContext } from "@tanstack/react-query";
import { useMarkRead, useNotifications } from "@/app/reviewQueries";
import { plural } from "@/lib/plural";

/** Колокольчик ленты (SP4): счётчик непрочитанных, список, «прочитано».
 *  Без QueryClient (изолированные тесты экранов) не рисуется. */
export function Bell() {
  const client = useContext(QueryClientContext);
  if (!client) return null;
  return <BellInner />;
}

function BellInner() {
  const q = useNotifications();
  const read = useMarkRead();
  const [open, setOpen] = useState(false);
  const unread = q.data?.unread ?? 0;
  const items = q.data?.items ?? [];
  return (
    <span className="relative">
      <button
        type="button"
        aria-label={unread ? `уведомления: ${unread} ${plural(unread, "непрочитанное", "непрочитанных", "непрочитанных")}` : "уведомления"}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="relative cursor-pointer rounded-sm border-0 bg-transparent px-1.5 py-1 font-mono text-[13px] text-mut hover:text-ink"
        data-testid="bell"
      >
        ◔
        {unread > 0 && (
          <span className="absolute -right-1 -top-1 rounded-full px-1 font-mono text-[9px] font-semibold" style={{ background: "var(--err)", color: "var(--accink)" }} data-testid="bell-count">
            {unread}
          </span>
        )}
      </button>
      {open && (
        <div role="dialog" aria-label="лента уведомлений" className="absolute right-0 top-8 z-30 w-[320px] rounded-md border border-bd bg-card shadow-md" data-testid="bell-panel">
          <div className="flex items-center justify-between border-b border-bd px-3 py-2 font-mono text-[11px] text-mut">
            <span>лента</span>
            {unread > 0 && (
              <button type="button" onClick={() => read.mutate({ all: true })} className="cursor-pointer border-0 bg-transparent p-0 font-mono text-[11px] text-acc hover:underline">
                всё прочитано
              </button>
            )}
          </div>
          {q.isError && <p className="m-0 px-3 py-3 text-[12.5px] text-err">Лента не загрузилась — проверь связь и открой колокольчик ещё раз.</p>}
          {!q.isError && items.length === 0 && <p className="m-0 px-3 py-3 text-[12.5px] text-ink2">Пока тихо: вердикты и ответы ментора появятся здесь.</p>}
          <ul className="m-0 max-h-[360px] list-none overflow-auto p-0">
            {items.map((n) => (
              <li key={n.id} className="border-b border-bd px-3 py-2.5 last:border-b-0" data-unread={!n.read_at} style={{ background: n.read_at ? undefined : "var(--accsoft)" }}>
                <div className="text-[12.5px] text-ink">{n.title}</div>
                {n.body && <div className="mt-0.5 text-[12px] leading-[1.45] text-ink2">{n.body}</div>}
                <div className="mt-1 font-mono text-[10.5px] text-ink2">{new Date(n.created_at).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </span>
  );
}
